<div class="summary-section">
  <ng-content></ng-content>
</div>
